export default __webpack_public_path__ + "static/media/project-screenshot.09e4f430.png";